/*
 * Don Castor: interacciones del design system que Dawn no trae.
 * Sin dependencias. No sustituye ni modifica los componentes de Dawn: solo los observa
 * (pubsub.js, cart-notification, product-form) y delega en ellos.
 */
(function () {
  'use strict';
  /* Una sola inicialización aunque el script se inserte varias veces (vista rápida de Dawn) */
  if (window.__dcUi) return;
  window.__dcUi = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(kind, key, value) {
    try {
      var s = window[kind];
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (e) { return null; }
  }

  /* --- Selección aleatoria: [data-dc-random-pick="N"] muestra N de sus [data-dc-pick-item] al azar en
     cada visita (en Liquid el azar quedaría fijo por la caché). Las posiciones pueden tener estilo
     propio con data-slot-<i>-tag (texto de [data-dc-pick-tag]) y data-slot-<i>-class. Sin JS, o si
     falla, se ven los N primeros que ya vienen visibles en el HTML. --- */
  function randomPick(group) {
    var count = parseInt(group.getAttribute('data-dc-random-pick'), 10) || 1;
    var items = $$('[data-dc-pick-item]', group);
    if (items.length > count) {
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
      var slotClasses = [];
      for (var k = 0; k < count; k++) {
        var c = group.getAttribute('data-slot-' + k + '-class');
        if (c) slotClasses.push(c);
      }
      items.forEach(function (item, index) {
        slotClasses.forEach(function (c) { item.classList.remove(c); });
        item.hidden = index >= count;
      });
      items.slice(0, count).forEach(function (item, index) {
        var slotClass = group.getAttribute('data-slot-' + index + '-class');
        var slotTag = group.getAttribute('data-slot-' + index + '-tag');
        if (slotClass) item.classList.add(slotClass);
        var tag = $('[data-dc-pick-tag]', item);
        if (tag && slotTag !== null) {
          tag.textContent = slotTag;
          tag.hidden = !slotTag;
        }
        group.appendChild(item);
      });
    }
    group.setAttribute('data-picked', '');
  }
  /* --- Medición de clics a WhatsApp (GTM): un solo listener delegado para cualquier enlace a wa.me
     o api.whatsapp.com. link_location = clave de la sección más cercana (p. ej. «cta», «footer»);
     fuera de secciones, la acción GA del botón («sticky») o «floating». dc-ui.js se inicializa una
     sola vez (window.__dcUi), así que el evento no se duplica. --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
    if (!a) return;
    var location = 'floating';
    var section = a.closest('.shopify-section');
    if (section && section.id) {
      var key = section.id.split('__').pop();
      location = key || section.id;
    } else if (a.getAttribute('data-ga-action') === 'sticky') {
      location = 'sticky';
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'whatsapp_click', link_url: a.href, link_location: location });
  });

  /* --- Acordeones de una sola pestaña abierta: los <details name="…"> del mismo grupo se cierran
     solos en navegadores actuales; en los que no soportan el atributo name, se hace aquí. --- */
  if (!('name' in document.createElement('details'))) {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      var group = d && d.getAttribute && d.getAttribute('name');
      if (!d.open || d.tagName !== 'DETAILS' || !group) return;
      $$('details[name="' + group + '"][open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }, true);
  }

  $$('[data-dc-random-pick]').forEach(randomPick);
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-dc-random-pick]', e.target).forEach(randomPick);
  });

  /* --- Barra fija del carrito (móvil): el total se escribe al cargar; cart.js re-renderiza el
     resumen al cambiar cantidades y aquí se copia el nuevo total. Carrito vacío: se oculta. --- */
  var stickyPrice = $('[data-dc-sticky-cta] [data-dc-sticky-price]');
  var cartFooter = $('#main-cart-footer');
  if (stickyPrice && cartFooter && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var total = $('.dc-cart-summary__total-value', cartFooter);
      var bar = stickyPrice.closest('[data-dc-sticky-cta]');
      if (total) stickyPrice.textContent = total.textContent.trim();
      if (bar) bar.hidden = cartFooter.classList.contains('is-empty');
    }).observe(cartFooter, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }

  /* --- Carga: barra superior (LoadingBar del DS) al navegar e imágenes con skeleton --- */
  var loadingBar = $('[data-dc-loading-bar]');
  function startLoading() {
    if (!loadingBar) return;
    loadingBar.classList.remove('is-active');
    void loadingBar.offsetWidth;
    loadingBar.classList.add('is-active');
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
    window.setTimeout(function () { if (!e.defaultPrevented) startLoading(); }, 0);
  });
  document.addEventListener('submit', function (e) {
    window.setTimeout(function () { if (!e.defaultPrevented) startLoading(); }, 0);
  });
  window.addEventListener('pageshow', function () {
    if (loadingBar) loadingBar.classList.remove('is-active');
  });

  function markLoaded(img) {
    var box = img.closest('.dc-skeleton-media');
    if (box) box.classList.add('is-loaded');
  }
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') markLoaded(e.target);
  }, true);
  document.addEventListener('error', function (e) {
    if (e.target && e.target.tagName === 'IMG') markLoaded(e.target);
  }, true);
  root.classList.add('dc-ui-ready');
  $$('.dc-skeleton-media').forEach(function (box) {
    var img = $('img', box);
    if (!img || img.complete) box.classList.add('is-loaded');
  });

  /* --- Scroll: cabecera flotante (> 140 px), progreso de lectura y volver arriba (> 600 px) --- */
  var backToTop = $('[data-dc-back-to-top]');
  var ticking = false;
  var lastY = window.pageYOffset || 0;
  var mobileNav = window.matchMedia('(max-width: 749px)');
  function navBusy() {
    return !!document.querySelector('.section-header details[open], .section-header .menu-opening') ||
      root.classList.contains('dc-filters-lock');
  }
  function onScroll() {
    var y = window.pageYOffset || root.scrollTop;
    if (y > 140) root.classList.add('dc-scrolled');
    else if (y < 100) root.classList.remove('dc-scrolled');
    /* Navegación flotante en móvil: se oculta al bajar y reaparece al subir */
    if (mobileNav.matches && !navBusy()) {
      if (y > 320 && y > lastY + 6) root.classList.add('dc-nav-hidden');
      else if (y < lastY - 6 || y < 140) root.classList.remove('dc-nav-hidden');
    } else {
      root.classList.remove('dc-nav-hidden');
    }
    lastY = y;
    var max = root.scrollHeight - window.innerHeight;
    root.style.setProperty('--dc-scroll-progress', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
    if (backToTop) backToTop.classList.toggle('is-visible', y > 600);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      var skip = $('#MainContent');
      if (skip) skip.focus({ preventScroll: true });
    });
  }

  /* --- Modo oscuro --- */
  function syncThemeToggles() {
    var dark = root.getAttribute('data-theme') === 'dark';
    $$('[data-dc-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      var label = dark ? btn.dataset.labelLight : btn.dataset.labelDark;
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
    var meta = $('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', getComputedStyle(document.body).backgroundColor);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-theme-toggle]');
    if (!btn) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme-transition', '');
    root.setAttribute('data-theme', next);
    store('localStorage', 'dc-theme', next);
    syncThemeToggles();
    window.setTimeout(function () { root.removeAttribute('data-theme-transition'); }, 260);
  });
  syncThemeToggles();

  /* --- Tarjeta de producto: muestras de madera (previsualizan foto y meta) --- */
  function swatchPreview(swatch, on) {
    var card = swatch.closest('[data-dc-card]');
    if (!card) return;
    var meta = $('[data-dc-card-meta]', card);
    var img = $('.dc-product-card__image:not(.dc-product-card__image--secondary)', card);
    var active = $('[data-dc-swatch][aria-checked="true"]', card);
    var source = on ? swatch : active;
    if (meta) {
      meta.textContent = source ? source.dataset.label : meta.dataset.default;
      meta.classList.toggle('is-wood', !!source);
    }
    if (img) {
      if (!img.dataset.original) { img.dataset.original = img.currentSrc || img.src; img.dataset.originalSrcset = img.getAttribute('srcset') || ''; }
      var url = source && source.dataset.image;
      if (url) { img.removeAttribute('srcset'); img.src = url; }
      else { img.src = img.dataset.original; if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset); }
    }
  }
  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var sw = e.target.closest && e.target.closest('[data-dc-swatch]');
      if (sw) swatchPreview(sw, true);
    });
  });
  ['mouseout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var sw = e.target.closest && e.target.closest('[data-dc-swatch]');
      if (sw) swatchPreview(sw, false);
    });
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-dc-swatch]');
    if (!sw) return;
    var group = sw.parentElement;
    var wasOn = sw.getAttribute('aria-checked') === 'true';
    $$('[data-dc-swatch]', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    if (!wasOn) sw.setAttribute('aria-checked', 'true');
    swatchPreview(sw, !wasOn);
  });

  /* --- Toast de carrito (cart-notification de Dawn): se cierra solo a los 4 s, u 8 s si
     muestra recomendaciones; se pausa con el puntero encima o el foco dentro --- */
  var notification = $('#cart-notification');
  var recsBox = notification ? $('[data-dc-cart-recs]', notification) : null;
  var toastTimer;
  function toastDelay() { return recsBox && !recsBox.hidden ? 8000 : 4000; }
  function scheduleToastClose() {
    window.clearTimeout(toastTimer);
    if (!notification || !notification.classList.contains('active')) return;
    if (notification.matches(':hover')) return;
    var focusInside = document.activeElement !== notification && notification.contains(document.activeElement);
    if (focusInside) return;
    toastTimer = window.setTimeout(function () {
      if (typeof notification.close === 'function') notification.close();
    }, toastDelay());
  }
  if (notification && 'MutationObserver' in window) {
    new MutationObserver(scheduleToastClose).observe(notification, { attributes: true, attributeFilter: ['class'] });
    notification.addEventListener('mouseenter', function () { window.clearTimeout(toastTimer); });
    notification.addEventListener('mouseleave', scheduleToastClose);
    notification.addEventListener('focusout', function () { window.setTimeout(scheduleToastClose, 0); });
  }

  /* --- Recomendaciones en el Toast: al agregar un producto se piden 2 complementarios
     (Search & Discovery) y, si no hay, 2 relacionados (algoritmo de Shopify) --- */
  function loadCartRecs(productId) {
    if (!recsBox || !recsBox.dataset.url || !productId) return;
    recsBox.hidden = true;
    recsBox.innerHTML = '';
    var request = function (intent) {
      var url = recsBox.dataset.url + '?section_id=dc-cart-recommendations&limit=2&product_id=' +
        encodeURIComponent(productId) + '&intent=' + intent;
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.dc-cart-recs');
      });
    };
    request('complementary').then(function (recs) {
      return recs || request('related');
    }).then(function (recs) {
      if (!recs) return;
      recsBox.innerHTML = '';
      recsBox.appendChild(recs);
      recsBox.hidden = false;
      scheduleToastClose();
    }).catch(function () {});
  }
  if (recsBox && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !event.cartData) return;
      var data = event.cartData;
      var productId = data.product_id || (data.items && data.items[0] && data.items[0].product_id);
      loadCartRecs(productId);
    });
  }

  var notificationProduct = $('#cart-notification-product');
  var notificationMessage = $('#cart-notification-product-title');
  if (notificationProduct && notificationMessage && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var text = $('.cart-notification-product__text', notificationProduct);
      notificationMessage.innerHTML = text ? text.innerHTML : '';
    }).observe(notificationProduct, { childList: true, subtree: true });
  }

  /* --- Campañas (UTM): se guardan al aterrizar (primer y último contacto, 30 días) y se
     pasan a formularios de contacto, atributos del carrito y, si se activa, a WhatsApp --- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var UTM_TTL = 30 * 24 * 3600 * 1000;
  function readUtm(key) {
    var raw = store('localStorage', key);
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      return data && data.at && Date.now() - data.at < UTM_TTL ? data : null;
    } catch (e) { return null; }
  }
  (function captureUtm() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var found = {};
    var any = false;
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v.slice(0, 120); any = true; }
    });
    if (!any) return;
    found.landing = window.location.pathname;
    found.at = Date.now();
    store('localStorage', 'dc-utm', JSON.stringify(found));
    if (!readUtm('dc-utm-first')) store('localStorage', 'dc-utm-first', JSON.stringify(found));
    store('sessionStorage', 'dc-utm-synced', null);
  })();
  var utm = readUtm('dc-utm');
  var utmFirst = readUtm('dc-utm-first');
  function utmSummary(data) {
    return data ? [data.utm_source, data.utm_medium, data.utm_campaign].filter(Boolean).join(' / ') : '';
  }

  if (utm && root.dataset.dcUtm !== 'off') {
    /* Formularios de contacto de Shopify (contacto, cotización, diseño): campos ocultos */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/contact"]')) return;
      if (form.querySelector('input[data-dc-utm]')) return;
      var fields = { 'UTM origen': utm.utm_source, 'UTM medio': utm.utm_medium, 'UTM campaña': utm.utm_campaign,
        'UTM término': utm.utm_term, 'UTM contenido': utm.utm_content, 'Página de entrada': utm.landing,
        'Primer contacto': utmSummary(utmFirst), 'gclid': utm.gclid, 'fbclid': utm.fbclid };
      Object.keys(fields).forEach(function (label) {
        if (!fields[label]) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + label + ']';
        input.value = fields[label];
        input.setAttribute('data-dc-utm', '');
        form.appendChild(input);
      });
    }, true);

    /* Atributos del carrito (una vez por sesión): quedan en el pedido del panel */
    if (!store('sessionStorage', 'dc-utm-synced') && window.routes && window.routes.cart_update_url) {
      var attrs = {};
      UTM_KEYS.forEach(function (k) { if (utm[k]) attrs[k] = utm[k]; });
      if (utm.landing) attrs.landing_page = utm.landing;
      if (utmFirst) attrs.first_touch = utmSummary(utmFirst);
      fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () { store('sessionStorage', 'dc-utm-synced', '1'); }).catch(function () {});
    }

    /* WhatsApp: referencia de campaña al final del mensaje (ajuste del tema, desactivado por defecto) */
    if (root.dataset.dcUtmWhatsapp === 'true') {
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href*="wa.me/"]');
        if (!a) return;
        try {
          var url = new URL(a.href);
          var text = url.searchParams.get('text') || '';
          if (text.indexOf('[ref: ') !== -1) return;
          url.searchParams.set('text', text + ' [ref: ' + utmSummary(utm) + ']');
          a.href = url.toString();
        } catch (err) {}
      }, true);
    }
  }

  /* --- Aviso de cookies --- */
  var cookie = $('[data-dc-cookie]');
  if (cookie) {
    var key = 'dc-cookie-consent';
    var saveConsent = function (analytics, marketing) {
      store('localStorage', key, JSON.stringify({ at: new Date().toISOString(), analytics: analytics, marketing: marketing }));
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent({ analytics: analytics, marketing: marketing, preferences: true, sale_of_data: marketing }, function () {});
      }
      cookie.classList.remove('is-visible');
      window.setTimeout(function () { cookie.hidden = true; }, 240);
    };
    if (!store('localStorage', key)) {
      cookie.hidden = false;
      window.setTimeout(function () { cookie.classList.add('is-visible'); }, 1100);
    }
    cookie.addEventListener('click', function (e) {
      var prefs = $('[data-dc-cookie-prefs]', cookie);
      if (e.target.closest('[data-dc-cookie-accept]')) saveConsent(true, true);
      else if (e.target.closest('[data-dc-cookie-reject]')) saveConsent(false, false);
      else if (e.target.closest('[data-dc-cookie-more]')) {
        var more = e.target.closest('[data-dc-cookie-more]');
        if (prefs.hidden) {
          prefs.hidden = false;
          more.dataset.labelChoose = more.textContent;
          more.textContent = more.dataset.labelSave;
        } else {
          saveConsent($('[data-dc-cookie-analytics]', cookie).checked, $('[data-dc-cookie-marketing]', cookie).checked);
        }
      }
    });
  }

  /* --- Mega menú: apertura al pasar el cursor en dispositivos con hover (el clic de Dawn sigue funcionando) --- */
  if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    $$('header-menu > details.mega-menu').forEach(function (details) {
      var closeTimer;
      var menu = details.parentElement;
      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        $$('header-menu > details[open]').forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
        if (!details.open) details.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(function () {
          if (!details.contains(document.activeElement)) details.removeAttribute('open');
        }, 120);
      });
    });
  }
})();
